import { Link } from "react-router-dom";
import DownArrow from "../../SvgComponents/DownArrow";
import { AnimatePresence, motion } from "framer-motion";
import { useState } from "react";
import PageWithSubpagesForMorePages from "./PageWithSubpagesForMorePages";

function MorePages(
    props: {
        pages: any
    }
) {

    const [dropdownMenu, setDropdownMenu] = useState<boolean>(false)
    const [arrowAngle, setArrowAngle] = useState<number>(0);
    
    function activateDropdown() {
      setArrowAngle(180);
      setDropdownMenu(true);
    }
  
    function deactivateDropdown() {
      setArrowAngle(0);
      setDropdownMenu(false);
    }

    const website_language = localStorage.getItem("website_language");

    return (
        <div
            className="flex items-center
                        text-white font-medium text-xl hover:text-white/70
                        transition-colors duration-200 ease-out
                        relative"
                onMouseEnter={() => activateDropdown()}
                onMouseLeave={() => deactivateDropdown()}
            >
                {website_language === "EN" ? "More" : "Mai multe"}
                <motion.div
                    animate={{
                    rotate: arrowAngle
                    }}
                    className="w-[62px] h-[62px]
                            flex items-center justify-center
                            stroke-white"
                >
                    <DownArrow />
                </motion.div>
            <AnimatePresence mode="wait">
                {
                    dropdownMenu && (
                        <motion.div
                            initial={{
                                top: 40,
                                opacity: 0
                            }}
                            animate={{
                                top: 62,
                                opacity: 1
                            }}
                            exit={{
                                top: 58,
                                opacity: 0
                            }}
                            transition={{
                                duration: 0.2,
                                ease: "easeOut"
                            }}
                            className="absolute
                                        left-0
                                        bg-[#076ca6]
                                        w-[300px]
                                        "
                            >
                            {
                                props.pages.filter((page: any) => page.pageLanguage === website_language).map((page: any, index: number) => (
                                    index > 5 ? 
                                        page.subPages.length > 0 ? 
                                            <PageWithSubpagesForMorePages page={page} index={index} />
                                            :
                                            <Link
                                            // eslint-disable-next-line
                                                to={page.pageLink}
                                                key={index}
                                                className="p-4
                                                        flex items-center
                                                        text-white
                                                        bg-[#076ca6] hover:bg-[#075887]"
                                            >
                                                <p>
                                                {page.pageName}
                                                </p>
                                            </Link>
                                    : ""
                                ))
                            }
                        </motion.div>
                    )
                }
            </AnimatePresence>
        </div>
  )
}

export default MorePages